import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/index';
import About from './pages/about';
import Experience from './pages/experience';
import Projects from './pages/projects';
import Blog from './pages/blog';
import BlogDetail from './pages/BlogDetail';
import Certificates from './pages/certificates';
import Contact from './pages/contact';
import ProjectDetail from './pages/ProjectDetail';
import Privacy from './pages/privacy';
import { LanguageProvider } from './context/LanguageContext';
import './App.css';

const Admin = lazy(() => import('./pages/admin'));

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';

  return (
    <div className="App">
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:idOrSlug" element={<BlogDetail />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gizlilik" element={<Privacy />} />
          <Route path="/admin" element={<Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-canvas"><div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" /></div>}><Admin /></Suspense>} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App;
